<template lang="pug">
div.pad5
  app-collapse(:title="item.pessoaFisica.nome" v-if="socios && socios.length > 0"  v-for="item in socios" :key="item._id")
    p
      span.label CPF:
      span.text &nbsp {{filterNull(item.pessoaFisica.cpf)}}
    p
      span.label RG:
      span.text &nbsp {{filterNull(item.pessoaFisica.rg)}}
    p
      span.label Órgão expedidor:
      span.text &nbsp {{filterNull(item.pessoaFisica.orgaoExpedidor.nome)}}
    p
      span.label UF do RG:
      span.text &nbsp {{item.pessoaFisica.orgaoExpedidor.estado || '-'}}
    p
      span.label Nacionalidade:
      span.text &nbsp {{filterNull(item.pessoaFisica.nacionalidade)}}
    p
      span.label Estado civil:
      span.text &nbsp {{estadoCivilFormatado(item.pessoaFisica.estadoCivil)}}
    p
      span.label Email:
      span.text &nbsp {{getEmail(item)}}
    app-resumo-documentos(:documentos="item.documentos")
</template>
<script>
import estadosBr from '@/constants/estados'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppCollapse from '@/components/AppCollapse'

export default {
  components: {
    AppResumoDocumentos,
    AppCollapse
  },
  props: {
    socios: {
      Type: Object,
      required: true
    }
  },
  data () {
    return {
      estadosBr
    }
  },
  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    },
    getEmail (interessado) {
      return interessado.email ? interessado.email : interessado.pessoaFisica.email ? interessado.pessoaFisica.email : '-'
    },
    getEstadoBySigla (sigla) {
      if (sigla) {
        const estado = this.estadosBr.filter((estado) => {
          return estado.codigo === sigla
        })
        return estado[0].nome
      }
      return '-'
    },
    estadoCivilFormatado (estadoCivil) {
      switch (estadoCivil) {
        case 'SOLTEIRO':
          return 'Solteiro'
        case 'CASADO':
          return 'Casado'
        case 'UNIAO_ESTAVEL':
          return 'União estável'
        case 'DIVORCIADO':
          return 'Divorciado'
        case 'VIUVO':
          return 'Viúvo'
        case 'SEPARADO':
          return 'Separado'
        case 'UNIAO_HOMOAFETIVA':
          return 'União homoafetiva'
        default:
          return '-'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
  color: #606266;
}

.text {
  color: #696580;
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoSocios.vue